var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"v-collective-gallery"}},[_c('img',{staticStyle:{"margin-top":"20px","margin-bottom":"60px"},attrs:{"src":require("../../assets/MockGalleryFeatures.png")}}),_c('br'),_vm._v(" "),_c('gallery',{attrs:{"collective":_vm.collective}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63c0616e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Collective/CollectiveGallery.vue
// module id = b9Ce
// module chunks = 1